// import { componentProps } from '@vue-leaflet/vue-leaflet/dist/src/functions/component'

const addInfo = {
  title: 'FleetAccessSettings',
  icon: 'fleet-access-settings'
}
const fleetAccessSettingsRouter = {
  path: '/fleet-access-settings',
  meta: {
    title: 'FleetAccessSettings',
    icon: 'fleet-access-settings',
    permission: ['user_enable', 'lite_access_enable', 'fleet_group_enable', 'role_enable', 'package_enable', 'audit_log_enable']
  },
  children: [
    {
      path: 'manage-user',
      component: () => import('@/views/fleet-access-settings/ManageUser/manage-user'),
      name: 'ManageUser',
      meta: { title: 'ManageUser', parent: addInfo, permission: ['user_enable'] }
    },
    {
      path: 'user-form/:id?',
      component: () => import('@/views/fleet-access-settings/ManageUser/user-form'),
      hidden: true,
      name: 'UserForm',
      meta: {
        title: 'UserForm',
        parent: addInfo,
        activeMenu: '/fleet-access-settings/manage-user',
        enableBack: true,
        backPage: 'ManageUser',
        permission: ['user_create', 'user_update']
      }
    },
    {
      path: 'manage-lite-access',
      component: () => import('@/views/fleet-access-settings/ManageLite/manage-lite-access'),
      name: 'ManageLite',
      meta: { title: 'ManageLite', parent: addInfo, permission: ['lite_access_enable'] }
    },
    {
      path: 'lite-user-form/:id?',
      component: () => import('@/views/fleet-access-settings/ManageLite/lite-user-form'),
      name: 'LiteUserForm',
      hidden: true,
      meta: {
        title: 'LiteUserForm',

        activeMenu: '/fleet-access-settings/manage-lite-access',
        enableBack: true,
        backPage: 'ManageLite',
        parent: addInfo,
        permission: ['lite_access_create', 'lite_access_update']
      }
    },
    {
      path: 'fleet-group-management',
      component: () => import('@/views/fleet-access-settings/FleetGroupManagement/fleet-group-management'),
      name: 'FleetGroupManagement',
      meta: { title: 'FleetGroupManagement', parent: addInfo, permission: ['fleet_group_enable'] }
    },
    {
      path: 'fleet-group-form/:id?',
      component: () => import('@/views/fleet-access-settings/FleetGroupManagement/fleet-group-form'),
      hidden: true,
      name: 'FleetGroupForm',
      meta: { title: 'FleetGroupForm', parent: addInfo, activeMenu: '/fleet-access-settings/fleet-group-management', enableBack: true, backPage: 'FleetGroupManagement', permission: ['fleet_group_create', 'fleet_group_update'] }
    },
    {
      path: 'company-management',
      component: () => import('@/views/fleet-access-settings/CompanyManagement/company-management'),
      name: 'CompanyManagement',
      meta: { title: 'CompanyManagement', parent: addInfo, permission: ['company_enable'] }
    },
    {
      path: 'create-company-form/:id?',
      component: () => import('@/views/fleet-access-settings/CompanyManagement/company-form'),
      hidden: true,
      name: 'CompanyForm',
      meta: { title: 'CompanyForm', parent: addInfo, activeMenu: '/fleet-access-settings/company-management', enableBack: true, backPage: 'CompanyManagement', permission: ['company_create'] }
    },
    {
      path: 'update-company-form/:id?',
      component: () => import('@/views/fleet-access-settings/CompanyManagement/company-form'),
      hidden: true,
      name: 'UpdateCompanyForm',
      meta: { title: 'CompanyForm', parent: addInfo, activeMenu: '/fleet-access-settings/company-management', enableBack: true, backPage: 'CompanyManagement', permission: ['company_update'] }
    },

    // {
    //   path: 'email-notification-settings',
    //   component: () => import('@/views/fleet-access-settings/EmailNotificationSettings/email-notification-settings'),
    //   name: 'EmailNotificationSettings',
    //   meta: { title: 'EmailNotificationSettings', parent: addInfo }
    // },
    // {
    //   path: 'email-notification-settings-form/:id?',
    //   component: () => import('@/views/fleet-access-settings/EmailNotificationSettings/email-notification-form'),
    //   hidden: true,
    //   name: 'EmailNotificationSettingsForm',
    //   meta: { title: 'EmailNotificationSettingsForm', parent: addInfo, activeMenu: '/fleet-access-settings/email-notification-settings' }
    // },

    {
      path: 'notification-settings',
      component: () => import('@/views/fleet-access-settings/NotificationSettings/notification-settings.vue'),
      name: 'NotificationSettings',
      meta: { title: 'NotificationSettings', parent: addInfo }
    },
    {
      path: 'notification-settings-form/:id?',
      component: () => import('@/views/fleet-access-settings/NotificationSettings/notification-form.vue'),
      hidden: true,
      name: 'NotificationSettingsForm',
      meta: {
        title: 'NotificationSettingsForm',
        parent: addInfo
      }
    },

    {
      path: 'roles-management',
      component: () => import('@/views/fleet-access-settings/RolesManagement/roles-management'),
      name: 'RolesManagement',
      meta: { title: 'RolesManagement', parent: addInfo, permission: ['role_enable'] }
    },
    {
      path: 'roles-form/:id?',
      component: () => import('@/views/fleet-access-settings/RolesManagement/roles-form'),
      hidden: true,
      name: 'RolesForm',
      meta: { title: 'RolesForm', parent: addInfo, activeMenu: '/fleet-access-settings/roles-management', enableBack: true, backPage: 'RolesManagement', permission: ['role_create', 'role_update'] }
    },
    {
      path: 'package-management',
      component: () => import('@/views/fleet-access-settings/PackageManagement/package-management'),
      name: 'PackageManagement',
      meta: { title: 'PackageManagement', parent: addInfo, permission: ['package_enable'] }
    },
    {
      path: 'package-form/:id?',
      component: () => import('@/views/fleet-access-settings/PackageManagement/package-form'),
      hidden: true,
      name: 'PackageForm',
      meta: { title: 'PackageForm', parent: addInfo, activeMenu: '/fleet-access-settings/package-management', enableBack: true, backPage: 'PackageManagement', permission: ['package_create', 'package_update'] }
    },
    {
      path: 'audit-logs',
      component: () => import('@/views/fleet-access-settings/AuditLogs/audit-logs'),
      name: 'AuditLogs',
      meta: { title: 'AuditLogs', parent: addInfo, permission: ['audit_log_enable'] }
    }
  ]
}

export default fleetAccessSettingsRouter
